import React from "react";
import EcommerceProject from "..//assests/portfolio/EcommerceProject.png";
import jobSearchProject from "../assests/portfolio/jobSearchProject.png";
import SugarProject from "../assests/portfolio/SugarProject.png";

const Portfolio = () => {
  const portfolios = [
    {
      id: 1,
      src: EcommerceProject,
      description: [
        "This is the full stack E-commerce project. The project includes the Indian handicrafts which user can order online.The images for this project is all generated by DALL·E2 and this project is completed with the assistance of chatGPT. The front end is completed with React and backend is completed with Django.The database use for this project is SQLite.The tailwind is used for the styling of this project",
      ],
      link: "https://6673fcb1769ada210658e434--jazzy-biscochitos-d45885.netlify.app/",
    },
    {
      id: 2,
      src: jobSearchProject,
      description: [
        "A React Job search project  with database created with Google Firebase. The user can see the job ads ,description of the postion. User can also filter the job ads according to their requirements.The new job ads is posted in google firebase as database",
      ],
      link: "https://portal-job-react.web.app/",
    },
    {
      id: 3,
      src: SugarProject,
      description: [
        "A complete flask based application to record the sugar levels with graphical representation,easy to register your records and can access anytime.This project was for my Online final project for CS50 Introduction to Computer Science from HarvardX.",
      ],
      link: "https://hiteshm.pythonanywhere.com/",
    },
  ];

  const handleDemoClick = (link) => {
    window.open(link, "_blank");
  };

  return (
    <div
      name="portfolio"
      id="Portfolio"
      className="bg-gradient-to-b from-black to-gray-800 w-full text-white min-h-screen"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-3xl md:py-6 font-bold inline border-b-4 border-gray-500">
            Portfolio
          </p>
          <p className="py-4 md:py-6 text-sm md:text-lg">Some of the Projects I worked on</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 px-4 sm:px-0">
          {portfolios.map(({ id, src, description, link, code }) => (
            <div key={id} className="shadow-md shadow-gray-600 rounded-lg overflow-hidden">
              <img
                src={src}
                alt="WalletProject"
                className=" w-full h-40 md:h-48 object-cover duration-200 hover:scale-105"
              />
              <div className="p-4">
              <p className="text-sm md:text-base mb-4">{description}</p>
              <div className="flex justify-center">

              <button
                  onClick={() => handleDemoClick(link)}
                  className="bg-red-500 text-white w-full sm:w-3/4 px-4 py-2 text-xs md:text-sm rounded-md duration-200 hover:scale-105"
                >
                  Click here for demo
                </button>
              </div>

              </div>
              </div>
              
             
            
          ))}
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
